import { render, staticRenderFns } from "./GenerateRideWithAi.vue?vue&type=template&id=070d622a&scoped=true"
import script from "./GenerateRideWithAi.vue?vue&type=script&lang=js"
export * from "./GenerateRideWithAi.vue?vue&type=script&lang=js"
import style0 from "./GenerateRideWithAi.vue?vue&type=style&index=0&id=070d622a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d622a",
  null
  
)

export default component.exports